// extracted by mini-css-extract-plugin
export default {"logoutContainer":"UserLogoff_logoutContainer__K+z1H","textStyles":"UserLogoff_textStyles__maUif","buttonStyles":"UserLogoff_buttonStyles__nNx36"};